import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=77ff59cc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ff59cc')) {
      api.createRecord('77ff59cc', component.options)
    } else {
      api.reload('77ff59cc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=77ff59cc&", function () {
      api.rerender('77ff59cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mk9Xo7LHfLW8/JS/comp/FavElement.vue"
export default component.exports